import { forwardRef } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { BoltFillIcon } from '@/icons';
import { type IconSize } from '@/icons/ZepIcon';
import { type PlanType } from '@/types';
import { cn } from '@/utils';
interface PlanIconProps {
  planType: Exclude<PlanType, 'FREE'>;
  iconSize?: IconSize;
  className?: string;
}
export const PlanIcon = forwardRef<HTMLSpanElement, PlanIconProps>(({
  planType,
  iconSize = '2xs',
  className
}, ref) => {
  return <span ref={ref} className={cn('rounded-full size-[22px] border-[2px] border-inverse flex items-center justify-center shadow-xs z-20', planType === 'BASIC' && 'bg-gradient-to-r from-mint-600 to-green-500', planType === 'PRO' && 'bg-gradient-to-r from-violet-400 to-blue-400', className)}>
        <BoltFillIcon size={iconSize} fill={ICON_COLOR.inverse} />
      </span>;
});
PlanIcon.displayName = 'PlanIcon';